const BASE_BACKEND_URL = import.meta.env.VITE_BASE_BACKEND_URL;
export const BASE_URL = `${BASE_BACKEND_URL}/`;

export enum URLS {
  SET_PASSWORD = '/set-password',
  LOGIN = '/login',
  FLIGHTS = '/flights',
  FLIGHT_OFFER = '/flights/offer/:offerId',
  FORGOT_PASSWORD = '/forgot-password',
}
